export default __webpack_public_path__ + "b121f4c0b00640a272e664b05cc7b066.png";